import React from 'react'
import moment from 'moment-timezone'

function JSONSchema ({ clinic, suburb, nearbySuburbs, reviewData, nextEvents }) {
  const schemas = []

  const address = {
    '@type': 'PostalAddress',
    addressCountry: 'AU',
    addressLocality: suburb.name,
    addressRegion: suburb.state,
    streetAddress: clinic.address,
    postalCode: suburb.postcode,
  }
  schemas.push({
    '@context': 'http://schema.org/',
    '@type': 'MedicalClinic',
    '@id': `${process.env.REACT_APP_APP_URL}/clinics/${clinic.id}`,
    name: clinic.name,
    priceRange: '$$',
    availableService: {
      '@type': 'MedicalTherapy',
      name: 'Physical therapy',
      alternateName: 'Physiotherapy',
      code: [
        { '@type': 'MedicalCode', codeValue: '93.0', codingSystem: 'ICD-9-CM' },
        { '@type': 'MedicalCode', codeValue: 'D026761', codingSystem: 'MeSH' },
      ],
    },
    openingHoursSpecification: clinic.openingHoursSpecification,
    address,
    areaServed: [
      suburb.name,
      ...nearbySuburbs,
    ],
    image: 'https://assets.localphysio.net.au/_next/static/images/team-222da2bcb6fd2cf87a92431651902182.jpg',
    aggregateRating: reviewData.count ? {
      '@type': 'AggregateRating',
      ratingValue: reviewData.average.toString(),
      ratingCount: reviewData.count,
      reviewCount: reviewData.count,
    } : undefined,
    ...(clinic.location || {}),
  })
  schemas.push(...nextEvents.map(e => ({
    '@context': 'http://schema.org/',
    '@type': 'Event',
    name: moment.unix(e.time).tz('Australia/Sydney').format('H:mm a')+ ` ${e.firstName} ${e.lastName}`,
    description: `Appointment with ${e.firstName} ${e.lastName}`,
    startDate: moment.unix(e.time).tz('Australia/Sydney').format('YYYY-MM-DDTHH:mm:ssZ'),
    endDate: moment.unix(e.time).tz('Australia/Sydney').add(30, 'minutes').format('YYYY-MM-DDTHH:mm:ssZ'),
    url: `${process.env.REACT_APP_APP_URL}/physiotherapy/${suburb.id}?booking=true&apId=${e.appointmentTypeId}&pId=${e.practitionerId}`,
    location: {
      '@id': `${process.env.REACT_APP_APP_URL}/clinics/${clinic.id}`,
    },
    organizer: {
      '@id': `${process.env.REACT_APP_APP_URL}/clinics/${clinic.id}`,
    },
    eventAttendanceMode: 'OfflineEventAttendanceMode',
    eventStatus: 'EventScheduled',
    performer: {
      '@type': 'Person',
      name: `${e.firstName} ${e.lastName}`,
    },
  })))

  return <React.Fragment>
    {schemas.map((s, i) => <script type={'application/ld+json'} key={`${s.type}-${i}`} dangerouslySetInnerHTML={{__html: JSON.stringify(s)}}/>)}
  </React.Fragment>
}

export default JSONSchema
